module.exports = __webpack_public_path__ + "static/media/sakshi_img_new.0a9536d9.jpeg";